import _get from 'lodash/fp/get'
import _setFp from 'lodash/fp/set'
import {createSelector} from 'reselect'
import produce from 'immer'
import {MODULE_STATE_NAME} from './constants'

// convert to mutable
const _set = _setFp.convert({'immutable': false})

const STATE_DEFAULT_VALUE = {
}

export const initState = () => ({...STATE_DEFAULT_VALUE})
export const resetState = () => ({...STATE_DEFAULT_VALUE})

/******************************** GETTER ********************************/
const getLocalState = (state) => state.getIn([MODULE_STATE_NAME]) || initState()
// const getLocalState = (state) => _get([MODULE_STATE_NAME], state) || initState()

export const getData = createSelector(
  getLocalState,
  _get(['filterValues', 'queryString'])
)


/******************************** UPDATER ********************************/

export const updaterTableSettings = (state, tableSettings) => produce(state, _set('tableSettings', tableSettings))

